/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconKeyboardArrowLeftFilled/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconKeyboardArrowLeftFilled({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconKeyboardArrowLeftFilled",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconKeyboardArrowLeftFilled.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-ZCRwts': alignSelf,'--mt-2-ZCRwts': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZCRwts': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZCRwts': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZCRwts': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZCRwts': opacity,'--w-10-ZCRwts': typeof width === 'number' ? `${width}px` : width,'--h-11-ZCRwts': typeof height === 'number' ? `${height}px` : height,'--a-7-ZCRwts': isAnimated ? animation : "none",'--sd-8-ZCRwts': isAnimated ? strokeDashoffset : 0,'--sd-9-ZCRwts': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconKeyboardArrowLeftFilled.SvgPath"
  data-view-path={viewPath}
 d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
 style={{'--f-12-ZCRwts': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}